module.exports = __webpack_public_path__ + "img/a6_01.fc247f6e.jpg";